import i18n from 'src/i18n/i18n'

const projectTypes = {
  TIME_AND_MATERIALS: 'time_and_materials',
  FIXED_FEE: 'fixed_fee',
  NON_BILLABLE: 'non_billable'
}

const selectOptions = [
  { value: projectTypes.TIME_AND_MATERIALS, 'label': i18n.t('project_type_time_and_materials') },
  { value: projectTypes.FIXED_FEE, 'label': i18n.t('project_type_fixed_fee') },
  { value: projectTypes.NON_BILLABLE, 'label': i18n.t('project_type_non_billable') }
]

export { projectTypes, selectOptions as projectTypesSelectOptions }
